import { Table, TableRow, TableHead, TableCell, TableBody, HeadCell, Button, DynamicIcon } from 'legion-ui';
import DataTableComponent from "../../../../src/pages/components/table/component.js";
import * as React from 'react';
export default {
  Table,
  TableRow,
  TableHead,
  TableCell,
  TableBody,
  HeadCell,
  Button,
  DynamicIcon,
  DataTableComponent,
  React
};